import TheProduct from '@elem/compPage/PowerKits48vSystem';
import { IPageStatus } from '@elem/compPage/PowerKits48vSystem/config/IPageStatus';
import { ProductProvider } from 'elem/compPage/PowerKits48vSystem/ProductProvider';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { redirectTo404 } from '@/utils';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';

const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd'; //是否是生产环境
const whiteLocaleList = ['us', 'eu', 'de', 'uk'];
// 产品详情页参数
const generalKey = 'product_pk_hub_5kva';
export default function Page({ SEO, timeLine, pageStatus, systemTime }: any) {
    const { gloproductlist, useLang } = useGlobal();
    const router = useRouter();
    const { locale = 'us' } = router;
    const { t } = useLang('power_kits_48v_system');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const initState = {
        systemTime,
        pageStatus,
        timeLine,
        productTabActive: 'Product',
    };
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    // 如果不存在该页面,返回404
    if (!productMsg.generalKey && gloproductlist.length && typeof window !== 'undefined') {
        return router.push(`${location.origin}/${router.locale}/404`);
    }

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="power-kits-5kva-48v-power-system" />
            <GtmPageLoad />
            <ProductProvider state={initState}>
                <TheProduct />
            </ProductProvider>
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, req, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/PowerKits48vSystem/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/PowerKits48vSystem/config/times/us.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }
    // 当前页面阶段
    let pageStatus = IPageStatus.statusA;
    if (debug) {
        // 是否进入调试状态
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusC?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            // 系统时间进入 statusB 时间段
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        } else if (isPrd) {
            // 系统时间不在上述时间段,且进入生产环境才跳转404
            return redirectTo404();
        }
    }
    return {
        props: {
            systemTime,
            timeLine,
            debug: debug || '',
            pageStatus,
        },
    };
}
